export enum ProductType {
  Regular = 0,
  Discovery = 1,
  Free = 2,
  LimitedAccess = 3,
}
